import React from 'react'

export const LoaderContext = React.createContext({
  loadedPercent: '0%',
  onLoadedPercent: null,
})
